export const CUSTOMER_ITEM_HEIGHT = 38;
